<template>
  <form @submit.prevent="$emit('submit')">
    <div class="flex flex-wrap pt-4">
      <text-input
        v-model="form.chapter.name"
        :errors="form.errors.name"
        class="w-full pb-8 pr-6"
        label="Nume"
      />
      <text-input
        v-model="form.position"
        :errors="form.errors.position"
        class="w-full pb-8 pr-6"
        type="Number"
        label="Pozitie"
        :min="1"
        :max="max"
      />
    </div>
    <slot />
  </form>
</template>

<script>
import TextInput from '@/Shared/TextInput.vue';

export default {
  components: {
    TextInput,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
  emits: ['update:modelValue', 'submit'],
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>
